<template>
  <v-card v-if="localEvaluation" min-width="850px">
    <v-form ref="form" v-model="valid" lazy-validation>
      <v-card-title>
        <span class="text-h5">{{ formTitle }}</span>
      </v-card-title>
      <v-card-text>
        <v-container grid-list-md>
          <v-row>
            <v-col sm="3" cols="12">
              <v-menu
                ref="menu1"
                :close-on-content-click="false"
                v-model="menu1"
                :nudge-right="40"
                :return-value.sync="localEvaluation.date"
                transition="scale-transition"
                offset-y
                min-width="290px"
              >
                <template v-slot:activator="{ on }">
                  <v-text-field
                    v-on="on"
                    v-model="localEvaluation.date"
                    label="* Date:"
                    prepend-icon="mdi-calendar"
                    readonly
                    :rules="[() => !!localEvaluation.date || 'Champ obligatoire']"
                  ></v-text-field>
                </template>
                <v-date-picker
                  locale="fr-CH"
                  first-day-of-week="1"
                  v-model="localEvaluation.date"
                  @input="$refs.menu1.save(localEvaluation.date)"
                ></v-date-picker>
              </v-menu>
            </v-col>
            <v-col cols="12" sm="6" v-if="evaluationVariants.length">
              <v-autocomplete
                placeholder="Compétence évalué"
                :items="evaluationVariants"
                v-model="localEvaluation.objective"
                clearable
              ></v-autocomplete>
            </v-col>
            <v-col cols="12" sm="6" v-else>
              <v-text-field label="Compétence évaluée" v-model="localEvaluation.objective"></v-text-field>
            </v-col>
            <v-col cols="12" sm="3">
              <v-text-field
                :rules="[numberRule]"
                label="Resultat"
                v-model="localEvaluation.result"
                required
                suffix="%"
              ></v-text-field>
            </v-col>
          </v-row>
        </v-container>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="blue darken-1" text @click.native="close">Annuler</v-btn>
        <v-btn :disabled="isDisabled" color="blue darken-1" text @click.native="save">Sauvegarder</v-btn>
      </v-card-actions>
    </v-form>
  </v-card>
</template>
<script>
import { cloneDeep } from "lodash"

export default {
  props: {
    evaluation: {
      required: true,
    },
    evaluation_type: {
      required: true,
    },
    formTitle: {
      type: String,
      default: "Modifier l'evaluation",
    },
  },
  mounted() {
    this.localEvaluation = cloneDeep(this.evaluation)
    this.localEvaluation.date ??= new Date().toLocaleDateString("en-CA")
  },
  watch: {
    evaluation: function () {
      this.localEvaluation = cloneDeep(this.evaluation)
      this.localEvaluation.date ??= new Date().toLocaleDateString("en-CA")
    },
  },
  data() {
    return {
      menu1: false,
      valid: false,
      localEvaluation: null,
      numberRule: (v) => {
        if (v && !isNaN(parseFloat(v)) && v >= 0 && v <= 100) return true
        return "Pourcentage max 100"
      },
    }
  },
  computed: {
    isDisabled() {
      return !this.localEvaluation?.date || !this.localEvaluation?.result
    },
    evaluationVariants() {
      let variants = []
      if (this.evaluation_type == "it") {
        variants = [
          "Utiliser des appareils à commande numérique",
          "Utiliser Internet",
          "Communiquer grâce aux TIC",
          "Assurer sa propre sécurité lors de l’utilisation des TIC",
          "Utiliser des prestations en ligne",
        ]
      }
      if (this.evaluation_type == "fr" || this.evaluation_type == "frdistance" || this.evaluation_type == "re" || this.evaluation_type == "cp") {
        variants = [
          "CO Compréhension orale",
          "CE Compréhension écrite",
          "PO Production orale",
          "PE Production écrite",
          "Lecture",
          "Nombres",
          "Dictée",
          "Structure de la langue",
        ]
      }
      return variants
    },
  },
  methods: {
    save() {
      this.$emit("save", this.localEvaluation)
    },
    close() {
      {
        this.$emit("cancel")
      }
    },
  },
}
</script>
